export default __webpack_public_path__ + "static/media/owner_robot.8512ea47.svg";